<app-loader *ngIf="isDisabled"></app-loader>
<div>
    <div class="row">
        <div class="col"></div>
        <div class="col-auto">
            <button *ngIf="this.common.PageRight.IsAdd" type="button" class="btn btn-primary" [disabled]="isDisabled"
                (click)="navigateToLocationComponent()">
                <i class="bi bi-person-fill-add" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Add Client':'Loading...'}}
            </button>
        </div>
    </div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            Client Group
        </div>
        <div class="card-body p-1">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">Action</th>
                        <th scope="col" style="display: none;">Client Group Master ID</th>
                        <th scope="col">Client Code</th>
                        <th scope="col">Client Name</th>
                        <th scope="col">Active</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let site of ClientData; let i = index">
                        <th scope="row">{{ i + 1 }}</th>
                        <td [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">
                            <div class="text-center">
                                <button class="btn btn-sm btn-group-toggle" style="height: 50%;"
                                    (click)="onEditClick(site)">
                                    <i class="bi bi-pencil-square text-warning"></i>
                                </button>
                            </div>
                        </td>
                        <td style="display: none;">{{ site['ClientGroupMasterID'] }}</td>
                        <td>{{ site['ClientGroupCode'] }}</td>
                        <td>{{ site['ClientGroupName'] }}</td>
                        <td>{{ site['Active'] ? 'Yes' : 'No'}}</td>
                    </tr>
                </tbody>
            </table>

        </div>

        <div class="card-footer">
            <div class="row">
                <div class="col"></div>
                <div class="col-auto">
                    <button (click)="exportToExcel('Client Master')" class="btn btn-primary btn-sm">
                        <i class="bi bi-file-earmark-arrow-down" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Excel':'Loading...'}}</button>
                </div>
                <!-- <div class="col-auto">
                    <button (click)="excelDownload()" class="btn btn-primary btn-sm">
                    <i class="bi bi-file-earmark-arrow-down" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Excel':'Loading...'}}</button>
                </div> -->
            </div>
        </div>
    </div>
</div>